import type { ICellRendererParams } from "ag-grid-community";
import type { Deal } from "@/types/deal";
import {
  daysInStatus,
  statusAgeColour,
  statusAgeTooltip,
} from "../pipelineMeeting";

/**
 * Meeting view Status cell: the status name followed by the number of days
 * the row has been in it (not shown for closed statuses or without history).
 * Hovering the number shows the date it entered the status.
 */
export function StatusAgeCell(params: ICellRendererParams<Deal>) {
  const label = params.valueFormatted ?? "";
  const days = params.data ? daysInStatus(params.data) : null;
  return (
    <span
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 6,
        width: "100%",
        minWidth: 0,
      }}
    >
      <span
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </span>
      {days !== null && (
        <span
          data-testid="status-age"
          title={params.data ? statusAgeTooltip(params.data) : undefined}
          style={{
            color: statusAgeColour(days),
            fontWeight: 600,
            fontVariantNumeric: "tabular-nums",
            flexShrink: 0,
          }}
        >
          {days}
        </span>
      )}
    </span>
  );
}
